<template>
  <header class="header" :class="{ 'solid-background': isSolidBackground }">
    <div class="container">
      <div class="header__inner">
        <a href="/" class="logo-wrapper">
          <img
            src="../../assets/images/logo.svg"
            class="desktop"
            alt="Aqua Expeditions Logo"
          />
          <img
            src="../../assets/images/logo-leaf.svg"
            class="mobile"
            alt="Aqua Expeditions Logo"
          />
          <span class="header__divider"></span>
          <span class="header__text">{{ portalHeader }}</span>
        </a>
        <a v-if="this.booking" href="/" class="logout_btn">Logout</a>
        <!--        <div-->
        <!--          v-if="hasValidUserData"-->
        <!--          class="hamburger-menu"-->
        <!--          @click="toggleMobileMenuDialog"-->
        <!--        >-->
        <!--          <img src="../../assets/images/menu.svg" alt="Aqua Expeditions Logo" />-->
        <!--        </div>-->
        <!--        <template v-if="!isLoadingUser && !hasValidUserData">-->
        <!--          <el-dropdown class="nav__dropdown" @command="handleCommand">-->
        <!--            <el-button @click="login">Login</el-button>-->
        <!--          </el-dropdown>-->
        <!--        </template>-->
        <!--        <template v-else-if="isLoadingUser">-->
        <!--          <el-dropdown class="nav__dropdown" @command="handleCommand">-->
        <!--            <el-button>Loading...</el-button>-->
        <!--          </el-dropdown>-->
        <!--        </template>-->
        <!--        <template v-else-if="!hasValidUserData">-->
        <!--          <el-dropdown class="nav__dropdown" @command="handleCommand">-->
        <!--            <el-button>Error loading profile</el-button>-->
        <!--            <el-dropdown-menu slot="dropdown">-->
        <!--              <el-dropdown-item command="logout">Log out</el-dropdown-item>-->
        <!--            </el-dropdown-menu>-->
        <!--          </el-dropdown>-->
        <!--        </template>-->
        <!--        <template v-else>-->
        <!--          <el-dropdown class="nav__dropdown" @command="handleCommand">-->
        <!--            <el-button class="nav__dropdownBtn">-->
        <!--              {{ userDisplay }}-->
        <!--            </el-button>-->
        <!--            <el-dropdown-menu slot="dropdown">-->
        <!--              <el-dropdown-item command="settings"-->
        <!--                >Account Settings</el-dropdown-item-->
        <!--              >-->
        <!--              <el-dropdown-item command="logout">Log out</el-dropdown-item>-->
        <!--            </el-dropdown-menu>-->
        <!--          </el-dropdown>-->
        <!--        </template>-->
      </div>
    </div>
    <!--    <el-row justify="center">-->
    <!--      &lt;!&ndash;<el-col :span="5" :offset="4" class="header-logo">&ndash;&gt;-->
    <!--      <el-col class="header-logo">-->
    <!--        <a href="http://www.aquaexpeditions.com/" target="_blank">-->
    <!--          <img alt="Aqua Expeditions Logo" class="logo"-->
    <!--               src="../../assets/images/logoWText@2x.png" />-->
    <!--        </a>-->
    <!--      </el-col>-->
    <!--      &lt;!&ndash;<el-col :span="13" tag="nav" class="navigation">&ndash;&gt;-->
    <!--      <el-col class="navigation" tag="nav">-->
    <!--        <ul>-->

    <!--          <li>-->
    <!--            <el-button class="nav__tag nav__resourceLibrary" type="text"-->
    <!--                       @click="updateHref('https://www.dropbox.com/sh/5atunm2lbk76vjc/AAAT5g-wGpIAC7GsAb6GaLo0a?dl=0')">-->
    <!--              <img class="nav_icon" src="../../assets/images/icn-agent-library.svg" />RESOURCE-->
    <!--              LIBRARY-->
    <!--            </el-button>-->
    <!--          </li>-->
    <!--&lt;!&ndash;          <li>&ndash;&gt;-->
    <!--&lt;!&ndash;            <el-button class="nav__tag nav__webinar" type="text"&ndash;&gt;-->
    <!--&lt;!&ndash;                       @click="updateHref('https://www.aquaexpeditions.com/webinars/')">&ndash;&gt;-->
    <!--&lt;!&ndash;              <img class="nav_icon" src="../../assets/images/icn-agent-webinar.svg" />WEBINAR&ndash;&gt;-->
    <!--&lt;!&ndash;            </el-button>&ndash;&gt;-->
    <!--&lt;!&ndash;          </li>&ndash;&gt;-->
    <!--          <li>-->
    <!--            <el-dropdown class="nav__dropdown" @command="handleCommand">-->
    <!--              <el-button class="nav__dropdownBtn">-->
    <!--                <img class="nav_icon"-->
    <!--                     src="../../assets/images/icn-agent-login.svg" />{{ getFirstName() }}<i-->
    <!--                  class="el-icon-arrow-down el-icon&#45;&#45;right"></i>-->
    <!--              </el-button>-->
    <!--              <el-dropdown-menu slot="dropdown">-->
    <!--                <el-dropdown-item command="logout">Log out</el-dropdown-item>-->
    <!--              </el-dropdown-menu>-->
    <!--            </el-dropdown>-->
    <!--          </li>-->
    <!--          &lt;!&ndash;<li v-for="nav in navLinks" :key="nav.label">&ndash;&gt;-->
    <!--          &lt;!&ndash;<el-button  type="text" @click="updateHref(nav.link)">{{nav.label}}</el-button>&ndash;&gt;-->
    <!--          &lt;!&ndash;</li>&ndash;&gt;-->
    <!--        </ul>-->
    <!--      </el-col>-->
    <!--    </el-row>-->
  </header>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { isEmpty } from "lodash";
import types from "../../store/types";

export default {
  name: "Navbar",
  props: {
    isSolidBackground: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters([
      "userDisplay",
      "isAgent",
      "isPressAccount",
      "isLoadingUser",
      "userData",
      types.getters.booking
    ]),
    hasValidUserData() {
      console.log("[Navbar.userDataEmpty] this.agentDetails:", this.userData);
      if (isEmpty(this.userData)) {
        return false;
      }
      return this.isAgent || this.isPressAccount;
    },
    portalHeader() {
      if (this.isAgent) {
        return "AGENT PORTAL";
      }
      return "ONLINE CHECK IN";
    },
  },
  methods: {
    ...mapActions(["logout", "clearAll", "toggleMobileMenu"]),
    updateHref(url) {
      window.open(url, "_blank");
    },
    login() {
      this.$auth.loginWithRedirect();
    },
    handleCommand(command) {
      switch (command) {
        case "logout":
          this.logout().then(() => {
            this.$router.push({ path: "/" });
          });
          break;
        case "settings":
          this.$router.push({ path: "/account-settings" });
      }
    },
    toggleMobileMenuDialog() {
      this.toggleMobileMenu();
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../scss/color.scss";
@import "../../scss/mixin.scss";
@import "../../scss/typography.scss";

.header {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  padding-top: 16px;
  padding-bottom: 16px;
  z-index: 101;
  background-color: rgba(102,117,129,0.15);
  -webkit-backdrop-filter: blur(12px);
  backdrop-filter: blur(12px);

  @include lg {
    padding-top: 24px;
    padding-bottom: 24px;
  }

  &__inner {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;

    a {
      display: flex;
      align-items: center;
      color: $white-100;
      text-decoration: none;

      + .logout_btn {
        padding: 10px 20px;
        font-size: 16px;
        text-transform: uppercase;
        border: 1px solid $white-100;
        border-radius: 4px;
        transition: all 300ms ease-in-out;

        &:hover {
          color: $aqua-grey-100;
          background-color: $white-100;
        }
      }
    }

    .hamburger-menu {
      display: flex;
      height: 20px;
      margin-left: auto;

      @include lg {
        display: none;
      }
    }
  }

  &__divider {
    width: 1px;
    height: 40px;
    margin-left: 16px;
    margin-right: 16px;
    background-color: #fff;

    @include lg {
      margin-left: 40px;
      margin-right: 24px;
    }
  }

  &__text {
    font-family: "century-gothic", "serif";
    font-size: 16px;
    line-height: 24px;
    color: #fff;
    text-align: center;
    @include global-paragraph-small-regular;

    @include lg {
      @include global-paragraph-medium-regular;
    }
  }
}

.header.solid-background {
  position: static;
  background-color: $aqua-grey-100;
}

.nav__tag {
  background: transparent;
  color: #ffffff;
  border-color: #ffffff;
  border-radius: 4px;
  font-size: 12px;
  line-height: 24px;
  padding: 8px 15px 8px 10px;
  margin-left: 20px;
}

.nav__resourceLibrary {
  width: 180px;
  height: 40px;
}

.nav__webinar {
  width: 112px;
  height: 40px;
}

ul.el-dropdown-menu.el-popper {
  width: 170px;
  //height: 40px;
  padding: 0;

  li.el-dropdown-menu__item {
    text-align: center;
  }
}

.nav__dropdown {
  display: none;

  @include lg {
    display: flex;
    margin-left: auto;
  }
}

.nav__dropdownBtn {
  margin-left: 20px;
  height: 40px;
  color: #373636;
  line-height: 24px;
  font-size: 12px;
  display: flex;
  align-items: center;
  text-transform: uppercase;

  img {
    margin-left: 8px;
    transform: translateY(4px);
  }
}

.nav_icon {
  padding-right: 5px;
  vertical-align: middle;
}

.logo-wrapper {
  .desktop {
    display: none;

    @include lg {
      display: flex;
    }
  }

  .mobile {
    display: flex;

    @include lg {
      display: none;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/layouts/Navbar.vue